import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useQueries from '../../../database/useQueries';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { getFieldOptions } from '../plagins/data/commponentOptions';
import hebrewDate from '../plagins/hebrewDate';
import useValidateIsraeliId from '../../template/form/components/validate/useValidateIsraeliId';
import FormTemplate from '../../template/form/FormTemplate';
import { GlobalContext } from '../../../App';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { addRecordToCache, createFetchDataServer, updateRecordInCache } from '../../../database/fetchData';
import { fullSelectedCities, fullSelectedCountries, fullSelectedCustomers } from '../plagins/data/multiSelectedForm';
import { format, parseISO } from 'date-fns';

// הגדרת שם הישות כקבוע
const NAME_ENTITY = 'לקוח';

function CustomerUpdate() {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsFormCustomers.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [loading, setLoading] = useState(true); // מצב טעינה

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataCustomer, getEntitiesByAttr, getEntityByAttr } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();
  const { value } = location.state || {};
  const [myCustomer, setMyCustomer] = useState(context?.contextCustomers?.find((item) => item?.unicId === value?.unicId) || value);

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    setMyCustomer(context?.contextCustomers?.find((item) => item?.unicId === value?.unicId) || value);
  }, [context?.contextCustomers, value]);

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`עדכון לקוח`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
  // משתנים לטופס
  const [fieldsWithDynamicDisabled, setFieldsWithDynamicDisabled] = useState([]); // השדות
  const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [spouse, setSpouse] = useState([]);

  const [jerusalemResident, setJerusalemResident] = useState(['city-auto-000015', 'city-auto-000028', 'city-auto-000081', 'city-auto-000390']);
  const [israelResident, setIsraelResident] = useState(['country-auto-0081']);

  // פונקציה לטעינת השדות מתוך הסטור
  const myColumns = (localColumns = null) => {
    localColumns = localColumns !== null ? localColumns : columns;
    return localColumns.map((field, index) => {
      let lock = false;
      let required = true;
      let show = true;
      required = field.name === 'spouse' && formValues.maritalStatus === 2 ? true : field?.required || false;
      show = field.name === 'spouse' && formValues.maritalStatus !== 2 ? false : true;

      return {
        ...field,
        disabled: lock ? lock : field.disabled,
        required: required,
        show: show
      };
    });
  };

  // פעולות המתבצעות רק לאחר קבלת דאטה בייס ווליו מהראוטר
  useEffect(() => {
    handleAllDataLoaded();
  }, [myCustomer]);

  // טעינת הנתונים לאחר קבלת הערכים מהדאטה בייס הלוקלי
  const handleAllDataLoaded = () => {
    setFieldsWithDynamicDisabled(myColumns());

    if (myCustomer?.unicId) {
      let initialFormValues = myColumns()
        .filter((field) => field?.name)
        .reduce(
          (acc, field) => {
            let fieldValue = myCustomer[field.name] || '';
            if (field.input === 'date') {
              try {
                const date = parseISO(fieldValue);
                fieldValue = format(date, 'yyyy-MM-dd');
              } catch (error) {
                fieldValue = ''; // ערך לא תקין, אפשר להחזיר ערך ריק או מה שמתאים לך
              }
            }
            return {
              ...acc,
              [field.name]: fieldValue
            };
          },
          {
            id: myCustomer?.id,
            unicId: myCustomer?.unicId
          }
        );

      setCountries(fullSelectedCountries(context?.contextCountries));
      setCities(fullSelectedCities(context?.contextCities));

      let filteredArray = [...context?.contextCustomers];
      if (initialFormValues?.maritalStatus === 2) {
        filteredArray = filteredArray.filter((cust) => {
          return cust.maritalStatus !== 2 || (cust.maritalStatus === 2 && cust.unicId === myCustomer.spouse);
        });
      } else {
        filteredArray = filteredArray.filter((cust) => cust?.maritalStatus !== 2);
      }
      setFieldsWithDynamicDisabled((prevFields) => {
        const newFields = myColumns(prevFields);
        return newFields.map((field) => {
          const existingField = prevFields.find((prevField) => prevField.name === field.name);
          return existingField ? { ...existingField, ...field } : field;
        });
      });
      setSpouse(fullSelectedCustomers(filteredArray));

      setFormValues(initialFormValues);
    }
  };

  // ----------------------------------

  useEffect(() => {
    setFieldsWithDynamicDisabled((prevFields) => {
      const newFields = myColumns(prevFields);

      return newFields.map((field) => {
        const existingField = prevFields.find((prevField) => prevField.name === field.name);
        return existingField ? { ...existingField, ...field } : field;

        // if (existingField) {
        //   return { ...existingField, ...field };
        // } else {
        //   return field;
        // }
      });
    });
  }, [formValues.maritalStatus, formValues.spouse]);

  const [id, setId] = useState('');
  const isValidId = useValidateIsraeliId(id);

  const updateResident = (formValues) => {
    const { typeId, countryId, cityId } = formValues;
    let resident = formValues.resident;

    // בודק אם הוא דרכון
    if (typeId === 2) {
      resident = 3;
    } else if (typeId === 1) {
      // בדיקת מדינה
      if (israelResident?.includes(countryId)) {
        if (jerusalemResident?.includes(cityId)) {
          resident = 1;
        } else {
          resident = 2;
        }
      } else if (countryId && countryId !== null && countryId !== '') {
        resident = 3;
      }
    }

    return { ...formValues, resident };
  };

  const fieldChangeCountryId = (event, newFormValues) => {
    delete newFormValues?.cityId;
    let tempCities = [];

    if (event.target.value !== '') {
      tempCities = getEntitiesByAttr(context?.contextCities, event.target.name, event.target.value);
    } else {
      tempCities = context?.contextCities;
    }
    setCities(fullSelectedCities(tempCities));
  };

  const fieldChangeCityId = (event, newFormValues) => {
    let countryId = newFormValues?.countryId;
    let tempCities = [];

    if (event.target.value !== '') {
      tempCities = getEntitiesByAttr(context?.contextCities, 'unicId', event.target.value);
      const city = getEntityByAttr(context?.contextCities, 'unicId', event.target.value);
      const country = getEntityByAttr(context?.contextCountries, 'unicId', city?.countryId);

      countryId = country?.unicId;
    } else {
      tempCities = getEntitiesByAttr(context?.contextCities, 'countryId', newFormValues?.countryId);
    }

    return { countryId };
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    // בדיקה ראשונית אם השדה comment שווה ל-'טעינה'
    if (formValues['comment'] === '888') {
      setErrors({});
      return true;
    }

    fieldsWithDynamicDisabled.forEach((field) => {
      if (field.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.name === 'numId' && field.notRepeat && formValues[field.name]) {
        const customers = context?.contextCustomers?.filter((item) => item?.unicId !== myCustomer?.unicId);
        if (customers.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
      // בדיקת אימות תז
      if (field.name === 'numId' && formValues[field.name]) {
        if (formValues['typeId'] === 1) {
          if (myCustomer?.numId !== formValues[field.name]) {
            if (!isValidId) {
              tempErrors[field.name] = `מספר זהוי ${formValues[field.name]} לא תקין`;
              formIsValid = false;
            }
          }
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleChange = (event) => {
    let newFormValues = formValues;
    if (event?.target?.name === 'countryId') {
      fieldChangeCountryId(event, newFormValues);
    }
    if (event?.target?.name === 'cityId') {
      let res = fieldChangeCityId(event, newFormValues);
      console.log('res: ', res);

      if (event.target.value !== '') {
        newFormValues = { ...newFormValues, countryId: res?.countryId };
      }
    }
    if (event?.target?.name === 'numId') {
      setId(event?.target?.value);
    }
    if (event?.target?.name === 'maritalStatus') {
      event?.target?.value === 1 && delete newFormValues?.spouse;

      console.log(264, newFormValues, event?.target?.name, event?.target?.value);

      setFieldsWithDynamicDisabled((prevFields) => {
        console.log(269, prevFields);

        // const newFields = myColumns(prevFields)?.filter( field => event?.target?.value === 1 && field?.name?.spouse );
        const newFields = myColumns(prevFields)?.filter((field) => {
          return !(event?.target?.value === 1 && field?.name === 'spouse');
        });

        console.log(270, newFields);
        return newFields.map((field) => {
          const existingField = prevFields.find((prevField) => prevField.name === field.name);
          return existingField ? { ...existingField, ...field } : field;
        });
      });
    }
    if (event?.target?.name === 'numId') {
      setId(event?.target?.value);
    }
    if (event?.target?.name === 'dateBirth') {
      let hebrewDateString = '';
      const inputDate = new Date(event.target.value);

      if (!isNaN(inputDate)) {
        hebrewDateString = hebrewDate(inputDate);
      }
      newFormValues = { ...newFormValues, ['dateBirthHe']: hebrewDateString };
    }
    newFormValues = { ...newFormValues, [event.target.name]: event.target.value };
    newFormValues = updateResident(newFormValues);
    setFormValues(newFormValues);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      setLoadingData(true);
      let updatedFormValues = { ...formValues };

      let res = await addOrUpdateDataCustomer(updatedFormValues);

      if (res === 200) {
        context?.setContextCustomers((prev) => {
          // חיפוש הערכים
          const existingCustomerIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);
          const existingOldSpouseIndex = prev.findIndex((item) => item.unicId === prev[existingCustomerIndex]?.spouse);
          const existingNewSpouseIndex = prev.findIndex((item) => item.unicId === updatedFormValues.spouse);

          // יצירת עותק של המערך
          let updatedState = [...prev];

          // עדכון הערכים הקיימים
          if (existingCustomerIndex !== -1) {
            updatedState[existingCustomerIndex] = {
              ...updatedState[existingCustomerIndex],
              ...updatedFormValues
            };
            updateRecordInCache({ ...updatedState[existingCustomerIndex], ...updatedFormValues }, 'dataCustomers');
          } else {
            updatedState.push(updatedFormValues);
            addRecordToCache(updatedFormValues, 'dataCustomers');
          }

          // אם קיים בן זוג ישן
          if (existingOldSpouseIndex !== -1) {
            let tempCustomer = { ...updatedState[existingOldSpouseIndex], spouse: null, maritalStatus: 1 };
            updatedState[existingOldSpouseIndex] = tempCustomer;
            updateRecordInCache(tempCustomer, 'dataCustomers');
          }

          // אם קיים בן זוג חדש
          if (existingNewSpouseIndex !== -1) {
            let tempCustomer = { ...updatedState[existingNewSpouseIndex], spouse: updatedFormValues.unicId, maritalStatus: 2 };
            updatedState[existingNewSpouseIndex] = tempCustomer;
            updateRecordInCache(tempCustomer, 'dataCustomers');
          }

          // החזרת המערך המעודכן
          return updatedState;
        });
        setLoadingData(false);
        navigate(-1);
        fetchDataServer(['customers'], token);
      }
    }
  };

  if (loadingData) return <LoadingOverlay />;

  return (
    <>
      {myCustomer && (
        <FormTemplate
          title={`עריכת ${NAME_ENTITY}`}
          btn={`עדכן`}
          fields={fieldsWithDynamicDisabled}
          columns={columns}
          formValues={formValues}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          errors={errors}
          options={{
            typeId: getFieldOptions('typeId', optionsFields),
            gender: getFieldOptions('gender', optionsFields),
            resident: getFieldOptions('resident', optionsFields),
            maritalStatus: getFieldOptions('maritalStatus', optionsFields),
            association: getFieldOptions('association', optionsFields),
            spouse,
            countryId: countries,
            cityId: cities
          }}
        />
      )}
      <p>
        <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>עריכת לקוח</span>
      </p>
    </>
  );
}

export default CustomerUpdate;
